import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import config from '../../config';
import { headers } from '../../token';
import { Link, useNavigate } from 'react-router-dom';
import validateError from '../../ValidateError';

const server_backend = config.API_URL;

function CreateCustomer({ username, onClose, getCustomers }) {
    const [loading, setLoading] = useState(false);
    const [BranchList, setBranchList] = useState([]);
    const navigate = useNavigate();
const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        lastname: "",
        email: "",
        phone: "",
        phone2: "",
        dni: "",
        address: "",
        city: "",
        zipcode: "",
        country: "",
        shipping_address: "",
        shipping_city: "",
        shipping_zipcode: "",
        shipping_country: "",
        contact_fullname: "",
        contact_phone: "",
        contact_email: "",
        reference1: "",
        reference2: "",
        comment: "",
        user_transaction: username,
    });


const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
  setErrors((prev) => ({ ...prev, [name]: false })); // remove error on change
};

const validateForm = () => {
  const requiredFields = ['name', 'lastname', 'email', 'phone'];
  const newErrors = {};

  requiredFields.forEach((field) => {
    if (!formData[field]?.trim()) {
      newErrors[field] = true;
    }
  });

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

    const handleCreate = async (e) => {
        e.preventDefault();
        setLoading(true);
        if(validateForm()) return;

        try {
            const response = await axios.post(`${server_backend}/Customers/insert`, formData, headers);
            if (response.data.RES_CODE === "00") {
                Swal.fire({
                    icon: 'success',
                    title: 'Created Successfully',
                    showConfirmButton: false,
                    timer: 2000
                });
                navigate('/customers');
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Customer already exists, please try another name',
                    showConfirmButton: false,
                    timer: 2000
                });
            }
        } catch (error) {
            const message = validateError(error);

            Swal.fire({
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content" style={{ overflow: "auto" }}>
            <div className="container-fluid">
                <div className="row">
                    <div className="card">
                        <div className="card-header">
                            <center>
                                <h4>Create Customer</h4>
                            </center>
                        </div>
                        <div className="card-header align-items-center d-flex">
                            <Link className='btn btn-warning' to="/customers" onClick={onClose}>Go Back</Link>
                        </div>

                        <div className="modal-body">
                            <form onSubmit={handleCreate}>
                                <div className="row">
                                    {/* Personal Information */}
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                                            placeholder="Enter your name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="lastname" className="form-label">Lastname</label>
                                        <input
                                            type="text"
                                            className={`form-control ${errors.lastname ? 'is-invalid' : ''}`}
                                            placeholder="Enter your lastname"
                                            name="lastname"
                                            value={formData.lastname}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                            placeholder="Enter your email"
                                            name="email"
                                            minLength={"7"}
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="dni" className="form-label">DNI</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your DNI"
                                            name="dni"
                                            value={formData.dni}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input
                                            type="tel"
                                            className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                                            placeholder="Enter phone number"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="phone2" className="form-label">Phone 2</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="Enter second phone number"
                                            name="phone2"
                                            value={formData.phone2}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your address"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="city" className="form-label">City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your city"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="zipcode" className="form-label">PostCode</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your zipcode"
                                            name="zipcode"
                                            value={formData.zipcode}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="country" className="form-label">Country</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter your country"
                                            name="country"
                                            value={formData.country}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="shipping_address" className="form-label">Shipping Address</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter shipping address"
                                            name="shipping_address"
                                            value={formData.shipping_address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="shipping_city" className="form-label">Shipping City</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter shipping city"
                                            name="shipping_city"
                                            value={formData.shipping_city}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="shipping_zipcode" className="form-label">Shipping PostCode</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter shipping zipcode"
                                            name="shipping_zipcode"
                                            value={formData.shipping_zipcode}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="shipping_country" className="form-label">Shipping Country</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter shipping country"
                                            name="shipping_country"
                                            value={formData.shipping_country}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="contact_fullname" className="form-label">Contact Fullname</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter contact fullname"
                                            name="contact_fullname"
                                            value={formData.contact_fullname}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="contact_phone" className="form-label">Contact Phone</label>
                                        <input
                                            type="tel"
                                            className="form-control"
                                            placeholder="Enter contact phone"
                                            name="contact_phone"
                                            value={formData.contact_phone}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="contact_email" className="form-label">Contact Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Enter contact email"
                                            name="contact_email"
                                            value={formData.contact_email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="reference1" className="form-label">Reference 1</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter reference 1"
                                            name="reference1"
                                            value={formData.reference1}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="reference2" className="form-label">Reference 2</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter reference 2"
                                            name="reference2"
                                            value={formData.reference2}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="col-md-12 mb-3">
                                        <label htmlFor="comment" className="form-label">Comment</label>
                                        <textarea
                                            className="form-control"
                                            placeholder="Enter comment"
                                            name="comment"
                                            value={formData.comment}
                                            onChange={handleChange}
                                        ></textarea>
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end'>
                                    <button className="btn btn-primary" type="submit" disabled={loading}>
                                        {loading ? "Creating..." : "Create Customer"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CreateCustomer;
